import {
    authorities,
    licences,
    ratings,
    testRatingCategories
} from "./dropdownData";

export const updateLicenceInformation = async ({ item, form }) => {
    form.setValues({
        "Credentials[Number]": item?.raw?.Credentials?.Number,
        "Authority": item?.raw?.Authority,
        "Credentials[Expiry]": item?.raw?.Credentials?.Expiry,
        "Credentials[Class]": item?.raw?.Credentials?.Class,
        "Credentials[Medical]": item?.raw?.Credentials?.Medical,
        "Licences": item?.raw?.Licences ? [item?.raw?.Licences].flat() : [],
        "Ratings[AeroplaneCategory]": item?.raw?.Ratings?.AeroplaneCategory,
        "Ratings[HelicopterCategory]": item?.raw?.Ratings?.HelicopterCategory,
        "Ratings_Others": item?.raw?.Ratings?.Others ? [item?.raw?.Ratings?.Others].flat() : []
    });

    console.log({
        "Credentials[Number]": item?.raw?.Credentials?.Number,
        "Authority": item?.raw?.Authority,
        "Credentials[Expiry]": item?.raw?.Credentials?.Expiry,
        "Credentials[Class]": item?.raw?.Credentials?.Class,
        "Credentials[Medical]": item?.raw?.Credentials?.Medical,
        "Licences": item?.raw?.Licences ? [item?.raw?.Licences].flat() : [],
        "Ratings[AeroplaneCategory]": item?.raw?.Ratings?.AeroplaneCategory,
        "Ratings[HelicopterCategory]": item?.raw?.Ratings?.HelicopterCategory,
        "Ratings_Others": item?.raw?.Ratings?.Others ? [item?.raw?.Ratings?.Others].flat() : []
    });

    form.setConfig({
        "title": "Update Information", 
        "type": "update",
        "location": `FlightTestCrew/${item.ID}`,
        "fields": [{
            "label": "Licence Infomation",
            "type": "sectionHeader",
            "divClass": "md:col-span-3 border-t border-t-1",
        }, {
            "label": "Licence Number",
            "name": "Credentials[Number]",
            "type": "text"
        }, {
            "label": "Licences",
            "name": "Licences",
            "type": "dropdown",
            "multiple": true,
            "dropdownData": licences
        }, {
            "label": "Licence Authority",
            "name": "Authority",
            "type": "dropdown",
            "dropdownData": authorities
        }, {
            "label": "Ratings Infomation",
            "type": "sectionHeader",
            "divClass": "md:col-span-3 border-t border-t-1",
        }, {
            "label": "Flight Test Rating (Aeroplane)",
            "name": "Ratings[AeroplaneCategory]",
            "type": "dropdown",
            "dropdownData": testRatingCategories
        }, {
            "label": "Flight Test Rating (Helicopter)",
            "name": "Ratings[HelicopterCategory]",
            "type": "dropdown",
            "dropdownData": testRatingCategories
        }, {
            "label": "Other Ratings",
            "name": "Ratings_Others",
            "type": "dropdown",
            "multiple": true,
            "dropdownData": ratings
        }, {
            "label": "Medical Infomation",
            "type": "sectionHeader",
            "divClass": "md:col-span-3 border-t border-t-1",
        }, {
            "label": "Medical Certificate Number",
            "name": "Credentials[Medical]",
            "type": "text"
        }, {
            "label": "Medical Class",
            "name": "Credentials[Class]",
            "type": "text"
        }, {
            "label": "Medical Expiry",
            "name": "Credentials[Expiry]",
            "type": "date"
        }],
        preSubmitHook({data}) {
            return {
                ...data,
                Ratings_Others: null,
                Ratings: {
                    ...data.Ratings,
                    Others: data.Ratings_Others
                }
            }
        }
    });

    form.getDropdownData();

    form.toggle();
};
